/**
 * Single source of truth for the storage keys that make up an in-progress exam
 * session: the unlock-key/timestamp/route triad, the Sentry school-code hint,
 * the examInProgress flag, and the localStorage assessment id.
 *
 * Any place that ends a session (user-initiated Quit, end-of-exam navigation,
 * SW reset, failed resume, TTL expiry, $routeChangeSuccess into /pwa-start)
 * must call clearSessionResumeStorage() so a new key added in future is wiped
 * everywhere automatically.
 */

const SESSION_STORAGE_KEYS = [
    'sessionResumeKey',
    'sessionResumeTimestamp',
    'sessionResumeRoute',
    'sentrySchoolCode',
    'examInProgress',
];

const LOCAL_STORAGE_KEYS = [
    'sessionResumeAssessmentId',
];

export function clearSessionResumeStorage(): void {
    SESSION_STORAGE_KEYS.forEach((k) => sessionStorage.removeItem(k));
    LOCAL_STORAGE_KEYS.forEach((k) => localStorage.removeItem(k));
}
